import React from "react";
import TopNav from "../Navbar/TopNav";
import Nav from "./../Navbar/Nav";

const Header = ({isActive}) => {
  return (
    <header className="header">
      <TopNav />
      <Nav isActive={isActive}/>
    </header>
  );
};

export default Header;
